import React, { Dispatch, SetStateAction } from "react";
import styles from "./TransparentTextField.module.scss";
interface TransparentTextFieldProps {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
}

function TransparentTextField(props: TransparentTextFieldProps) {
  const { value, setValue } = props;

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    let inputValue = event.target.value;

    if (/^[0-9]*[.,]?[0-9]*$/.test(inputValue)) {
      inputValue = inputValue.replace(",", ".");

      const [, decimalPart] = inputValue.split(".");
      if (decimalPart && decimalPart.length > 2) {
        return;
      }

      setValue(inputValue);
    }
  };

  return (
    <div className={styles.transparentTextFieldWrapper}>
      <input
        type="decimal"
        inputMode="decimal"
        step={0.01}
        placeholder="0.00"
        value={value}
        onChange={handleChange}
        className={styles.transparentTextField}
      />
      <div className={`headline-medium ${styles.prefix}`}>zł</div>
    </div>
  );
}

export default TransparentTextField;
